import { render, staticRenderFns } from "./FantastikLotteryStream.vue?vue&type=template&id=09766205&scoped=true&"
import script from "./FantastikLotteryStream.vue?vue&type=script&lang=js&"
export * from "./FantastikLotteryStream.vue?vue&type=script&lang=js&"
import style0 from "./FantastikLotteryStream.vue?vue&type=style&index=0&id=09766205&scoped=true&lang=scss&"
import style1 from "./FantastikLotteryStream.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09766205",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VResponsive,VRow})
